import { Component } from '@angular/core';
import { AngularModule } from '../../../../../modules/angular.module';
import { AdminClientSelectorFormComponent } from '../../../../forms/standard/admin-client-selector-form/admin-client-selector-form.component';
import { NavigationService } from '../../../../../services/navigation.service';
import { ClientService } from '../../../../../services/client.service';

@Component({
	selector: 'app-admin-client-selector',
	standalone: true,
	imports: [AngularModule, AdminClientSelectorFormComponent],
	templateUrl: './admin-client-selector.component.html',
	styleUrl: './admin-client-selector.component.scss',
})
export class AdminClientSelectorComponent {
	constructor(
		public nav: NavigationService,
		private clientService: ClientService
	) {}

	public async onChange(clientUuid: string) {
		await this.clientService.adminSelectClient$(clientUuid);
	}
}
